import { useEffect } from "react";
import { useCreditChoice, CreditType } from "@perxis-auto/credit-sdk";
import { isDefined } from "@perxis-auto/shared";
import "redux";
import { useAppDispatch } from "../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../model/index.js";
import { useCreditData } from "./useCreditData.js";
import { useCreditDataFetch } from "./useCreditDataFetch.js";
import { actions } from "../model/slice.js";
function useCreditDataCard({ vehicleId = "", model, price }) {
  var _a, _b, _c, _d;
  const dispatch = useAppDispatch();
  const {
    data: choice,
    actions: { setCar, setCreditParameters, setFinancialProgram }
  } = useCreditChoice();
  const creditData = useCreditData(vehicleId);
  const fetchCreditData = useCreditDataFetch({
    vehicleId,
    model,
    price
  });
  const isCreditProgramExist = isDefined((_a = creditData == null ? void 0 : creditData.choice) == null ? void 0 : _a.program);
  const isCreditParametersExist = isDefined((_b = creditData == null ? void 0 : creditData.choice) == null ? void 0 : _b.type) && isDefined((_c = creditData == null ? void 0 : creditData.choice) == null ? void 0 : _c.downPayment) && isDefined((_d = creditData == null ? void 0 : creditData.choice) == null ? void 0 : _d.numberOfPeriods);
  useEffect(() => {
    setCar({
      model: model ?? null,
      price: price ?? null
    });
  }, [price, model]);
  useEffect(() => {
    var _a2, _b2;
    if (isDefined(price) && isDefined((_a2 = creditData == null ? void 0 : creditData.choice) == null ? void 0 : _a2.price) && price !== ((_b2 = creditData == null ? void 0 : creditData.choice) == null ? void 0 : _b2.price)) {
      void fetchCreditData();
    }
  }, [price, creditData, fetchCreditData]);
  useEffect(() => {
    var _a2;
    if (isCreditParametersExist) {
      setCreditParameters({
        type: creditData.choice.type,
        downPayment: creditData.choice.downPayment,
        residualPayment: ((_a2 = creditData == null ? void 0 : creditData.choice) == null ? void 0 : _a2.residualPayment) ?? null,
        numberOfPeriods: creditData.choice.numberOfPeriods
      });
    }
    if (isCreditProgramExist) {
      setFinancialProgram({
        program: creditData.choice.program
      });
    }
    if (!creditData) {
      setCreditParameters({
        type: CreditType.ANNUITY,
        downPayment: 50,
        residualPayment: null,
        numberOfPeriods: 48
      });
      setFinancialProgram({
        program: null
      });
    }
  }, [isCreditParametersExist, isCreditProgramExist, creditData]);
  useEffect(() => {
    if (!creditData) {
      void fetchCreditData();
    }
  }, [vehicleId, creditData, fetchCreditData]);
  useEffect(() => {
    if (isDefined(vehicleId) && isDefined(choice) && isDefined(creditData) && isDefined(creditData.choice) && creditData.choice !== choice) {
      dispatch(
        actions.setOne({
          vehicleId,
          choice,
          previewProgram: creditData.previewProgram,
          isSelected: isDefined(choice.program)
        })
      );
    }
  }, [choice]);
  return creditData;
}
export {
  useCreditDataCard
};
